import React, { PropsWithChildren } from 'react'
import { ButtonToolbar } from 'react-bootstrap'
import classNames from 'classnames'
import _ from 'lodash'

import Breadcrumbs, { Crumb } from 'common/ui/Breadcrumbs'

import 'common/ui/AppContent.sass'

interface Props {
  crumbs?: readonly Crumb[]
  title?: React.ReactNode
  actions?: React.ReactNode
  sidebar?: React.ReactNode
  wide?: boolean
  breadcrumbsFullWidth?: boolean
  hideHeading?: boolean
}

export default function AppContent({
  crumbs = [],
  title,
  children,
  actions,
  sidebar,
  wide = false,
  breadcrumbsFullWidth = true,
  hideHeading = false,
}: PropsWithChildren<Props>): JSX.Element {
  const showHeader = crumbs.length > 0 || Boolean(title) || Boolean(actions)

  return (
    <main
      className={classNames({
        main: true,
        'main--wide': wide,
        'main--breadcrumbs-contained': !breadcrumbsFullWidth,
      })}
    >
      <div className="main__content">
        {showHeader && (
          <header className="main__header">
            <Breadcrumbs className="main__breadcrumbs" crumbs={crumbs} />
            {!hideHeading && (
              <h2 className="main__heading">{title || _.last(crumbs)?.text}</h2>
            )}
            <ButtonToolbar className="main__toolbar">{actions}</ButtonToolbar>
          </header>
        )}
        {children}
      </div>
      {sidebar && <aside className="main__sidebar">{sidebar}</aside>}
    </main>
  )
}
